import * as fs from "fs";
import * as ko from "knockout";
import { MainViewModel } from "../../main";

export class DialogViewModel {
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalSelectedObject = ko.observable(null);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();
    givenId = "modal";

    modalEdit() {
        switch (this.modalTitle()) {
            case "Referat": {
                MainViewModel.RoutingTable.showUnitAdd();
                break;
            }
            case "Sachbearbeiter": {
                //auf SA Pfad verweisen
                break;
            }
            case "Referat": {
                MainViewModel.RoutingTable.showDatamanagementOverview();
            }
        }
    }


    modalPick() {
        if (this.modalHandleSelection !== null) this.modalHandleSelection()(this.modalSelectedObject);
        $(`#${this.givenId}`).modal('hide');
    };



    modalSelect = (obj, event) => {
        $("#modalTable tr").removeClass("active");
        $(event.target.parentElement).addClass("active");
        this.modalSelectedObject(obj);
    }

    constructor(params: any) {
        if (params.prefix) {
            this.givenId = params.prefix + this.givenId;
        }
        this.modalTitle = params.modalTitle;
        this.modalKeys = params.modalKeys;
        this.modalColumns = params.modalColumns;
        this.modalData = params.modalData;
        this.modalHandleSelection = params.modalHandleSelection;
    }
}

let html = fs.readFileSync(__dirname + '/dialog.html', 'utf8');

ko.components.register("dialog-view", {
    viewModel: DialogViewModel,
    template: html
});
